
import Layout from "../adminComponents/Layout";
import { Navbar, Footer,Dashboard } from "../adminComponents";

function Home() {
    if (localStorage.getItem('eshopBranchID') === null || localStorage.getItem('eshopBranchID') === 'undefined') {
    window.location.replace('/adminLogin');
  }
  return (
    <>
      <Navbar/>
      <div className="container" > 
        <Dashboard/>
      </div>
      <Footer/>
    </>
  )
}

export default Home